import { Injectable, inject } from '@angular/core';
import { TwcRefreshLayerPluginService } from '../../../../twc.refresh-layer-plugin.service';
import { VOLCANIC_POINTS_PRODUCT_DATA } from './volcanic-points.twc-product-data';

@Injectable({
  providedIn: 'root'
})
export class VolcanicPointsPluginService {
  private _twcPluginService = inject(TwcRefreshLayerPluginService);

  plugin$ = this._twcPluginService.create(VOLCANIC_POINTS_PRODUCT_DATA, {
    twcLayerTypes: ['geojson']
  });
}
